<template></template>

<script>
import * as XLSX from "xlsx";

export default {
  name: "ExportToExcel",
  props: {
    employeeData: {
      type: Array,
      required: true,
    },
    orgConfig: Object,
  },
  computed: {
    mappingField() {
      if (this.orgConfig?.enabledSubCases?.length) {
        const allSubCase = this.orgConfig.enabledSubCases[0];
        const firstSubCaseCustomer =
          allSubCase.subCase[0]?.fieldMappings?.customerFullName?.displayName ||
          "Customer";
        const firstCaseNo =
          allSubCase.subCase[0]?.fieldMappings?.caseNo?.displayName ||
          "Customer";
        return { firstSubCaseCustomer, firstCaseNo };
      }
      return { firstSubCaseCustomer: "Customer", firstCaseNo: "Case Number" };
    },
  },
  methods: {
    exportToExcel() {
      let serialNumber = 1;
      const exportData = this.employeeData.flatMap((employee) => {
        if (!employee.locationData || employee.locationData.length === 0) {
          return [];
        }
        const dateVisits = employee.locationData.reduce((acc, location) => {
          if (!location.travelDate) return acc;
          const travelDate = this.$dayjs(location.travelDate).format(
            "DD/MM/YYYY"
          );
          if (!acc[travelDate]) {
            acc[travelDate] = [];
          }
          acc[travelDate].push(location);
          return acc;
        }, {});

        const employeeEntries = Object.keys(dateVisits)
          ?.flatMap((date) => {
            const visits = dateVisits[date];
            if (!visits || visits.length === 0) return [];
            const totalVisits = visits?.reduce((count, visit) => {
              const visitCount = visit.locationData.filter(
                (loc) =>
                  loc.activity.caseTaskDetails?.actualStartDateTime &&
                  loc.activity.action === "taskEnded"
              ).length;
              return count + visitCount;
            }, 0);

            let isFirstEntryForDate = true;

            return visits?.flatMap((visit) => {
              const visitTimeDetails = visit.locationData
                ?.filter(
                  (loc) =>
                    loc.activity.caseTaskDetails?.actualStartDateTime &&
                    loc.activity.action === "taskEnded"
                )
                ?.map((loc) => ({
                  caseNo: loc.activity.caseTaskDetails?.case?.caseNo,
                  visitTime: this.$dayjs(
                    loc.activity.caseTaskDetails?.actualStartDateTime
                  ).format("DD/MM/YYYY HH:mm A"),
                  visitAddress: loc.location?.formatted_address,
                  customerName:
                    loc.activity.caseTaskDetails?.case?.customer
                      ?.customerFullName,
                  visitCount: 1,
                }));
              if (!visitTimeDetails || visitTimeDetails.length === 0) {
                return [];
              }

              return visitTimeDetails?.map((detail) => {
                const entry = {
                  "S.No": date ? serialNumber : "",
                  "Travel Date": date,
                  "Employee Name": employee.fullName || "",
                  "Employee Id": employee.employeeId || "",
                  "Reporting Manager": employee?.reportesTo || "",
                  "Branch Name": employee?.branch || "",
                  [`${this.mappingField.firstCaseNo}`]: detail.caseNo,
                  "Visit Date/Time": detail.visitTime,
                  "Visit start address": detail.visitAddress || "",
                  [`${this.mappingField.firstSubCaseCustomer}`]:
                    detail.customerName,
                  "Visit Count": detail.visitCount,
                  "Total Visits": isFirstEntryForDate
                    ? `Total visit by ${employee.fullName} on ${date} - (${totalVisits})`
                    : "",
                };

                if (date) {
                  serialNumber++;
                }

                if (isFirstEntryForDate) {
                  isFirstEntryForDate = false;
                }

                return entry;
              });
            });
          })
          .filter((entry) => Object.values(entry).some((value) => value));

        if (!employeeEntries || employeeEntries.length === 0) {
          return [];
        }

        return employeeEntries;
      });

      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Employee Data");

      XLSX.writeFile(wb, "Employee_Visit_Data.xlsx");
    },
  },
  mounted() {
    this.$root.$on("export-daily-excel", this.exportToExcel);
  },
  beforeDestroy() {
    this.$root.$off("export-daily-excel", this.exportToExcel);
  },
};
</script>
